import { BuildingOutlineIcon } from '@/components/atoms/icons';
import { WebAccordion } from '@/components/molecules';
import React from 'react';
import type {
  GuestDetailsLayout,
  GuestDetailsTypeScale,
} from '../constants/guestLayout';
import type { GuestLabels } from '../constants/getGuestLabels';
import { getGuestWebAccordionFrame } from '../details/guestDetailsAccordionPad';
import type { GuestUnitDetailsModel } from '../types/guest.types';
import {
  GuestUnitAboutSections,
  hasGuestAboutContent,
} from './GuestUnitAboutSections';

export interface GuestUnitAboutAccordionProps {
  readonly unit: GuestUnitDetailsModel;
  readonly layout: GuestDetailsLayout;
  readonly typeScale: GuestDetailsTypeScale;
  readonly labels: GuestLabels;
  /** ADHA home: omit Unit Type tags from About Property. */
  readonly hideUnitType?: boolean;
  /**
   * Guest default: expanded. ADHA listing passes `false` (closed by default).
   * @default true
   */
  readonly defaultExpanded?: boolean;
}

/** About Property — hidden when units / types / amenities are all empty. */
export function GuestUnitAboutAccordion({
  unit,
  layout,
  typeScale,
  labels,
  hideUnitType = false,
  defaultExpanded = true,
}: Readonly<GuestUnitAboutAccordionProps>) {
  if (!hasGuestAboutContent(unit, { hideUnitType })) {
    return null;
  }

  const frame = getGuestWebAccordionFrame(layout);

  return (
    <WebAccordion
      icon={BuildingOutlineIcon}
      title={labels.aboutProperty}
      variant="large"
      defaultExpanded={defaultExpanded}
      titleVariant={typeScale.accordionTitle}
      sectionGap={0}
      {...frame}
    >
      <GuestUnitAboutSections
        unit={unit}
        layout={layout}
        typeScale={typeScale}
        labels={labels}
        hideUnitType={hideUnitType}
      />
    </WebAccordion>
  );
}

export default GuestUnitAboutAccordion;
